// extracted by mini-css-extract-plugin
export default {"modal":"sllITSEuJT4IKpGHl6gQ","content":"jLIXfKQDItwG79efKgSW"};